import { pick } from 'lodash-es'
import type { PropsWithChildren } from 'react'
import { useMyInfo } from 'src/services/apollo/auth'
import type { User } from 'src/services/apollo/generated/graphql'
import { useGetUserProfiles } from 'src/services/apollo/profile'
import { UserProfileContext } from './UserProfile.context'

export default function UserProfileProvider(
  props: PropsWithChildren<{ user: User; tab: string }>,
) {
  const { data: me } = useMyInfo()
  const { data: profileData } = useGetUserProfiles(props.user?.id)
  const { profiles } = profileData || {}

  const context = {
    user: props.user,
    tab: props.tab,
    profile: pick(profiles, [
      'bio',
      'location',
      'website',
      'twitterId',
      'instagramId',
      'facebookId',
      'redditId',
      'pixivId',
    ]),
    isMyProfile: Boolean(me && me.id === props.user?.id),
  }

  return (
    <UserProfileContext.Provider value={context}>
      {props.children}
    </UserProfileContext.Provider>
  )
}
